<div class="soft-loading-bar" aria-roledescription="loading-bar">
  <span
    class="soft-loading-bar-indicator"
    role="progressbar"
    aria-roledescription="loading-bar indicator"
  ></span>
</div>
